import { render, staticRenderFns } from "./BlockCard.vue?vue&type=template&id=0cc94fde&scoped=true"
import script from "./BlockCard.vue?vue&type=script&lang=js"
export * from "./BlockCard.vue?vue&type=script&lang=js"
import style0 from "./BlockCard.vue?vue&type=style&index=0&id=0cc94fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc94fde",
  null
  
)

export default component.exports